import { render, staticRenderFns } from "./InterpretationRevalidationHistoryForm.vue?vue&type=template&id=d62f569a&"
import script from "./InterpretationRevalidationHistoryForm.vue?vue&type=script&lang=js&"
export * from "./InterpretationRevalidationHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports